import React, { Component } from 'react';
import Header from './../../Header';
class Help extends Component {
  render() {
    return(
      <div>
       <Header brecum_name="Help" brecum_page="Help" />
        <div class="right_col">
          <div class="ticket_list">
           <h5 class="title">Help</h5>
           <h2>The page will coming very soon....</h2>
          </div>
        </div>
     </div>
    )
  }
  componentDidMount() {
    document.title = "Intranet | Help";
}
}
export default Help;


// WEBPACK FOOTER //
// ./src/components/help/Help.js